module.exports = __webpack_public_path__ + "static/img/iphone_ldttitle4.d030df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldttitle4.png
// module id = Wdad
// module chunks = 0